import React, { useEffect } from 'react';
import '../../../scss/pages/Home/WeeklyContest/weeklyContest.scss';
import crown from '../../../asset/svg/crown.svg'
import coinsWon from '../../../asset/svg/coinsWon.svg'
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from "react-router-dom";
import { WEEKLY_CONTEST } from '../../../utils/Constants';
import { DASHBOARD_WEEKLY_CONTEST } from '../../../sagas/type';
import { getLocalStoreString } from '../../../utils/Helper';
import { useDispatch, useSelector } from 'react-redux';
import clevertap from 'clevertap-web-sdk';
import { server } from '../../../configs/AppConfig';

function weeklyContest() {

    const navigate = useNavigate()
    const { pathname } = useLocation();
    const dispatch = useDispatch()
    const { dashboardWeeklyContest, } = useSelector(mapStateToProps);

    const myRank = 'My Rank >'

    useEffect(() => {
        weeklyContestData()
    }, [])

    const weeklyContestData = () => {
        const contestId = getLocalStoreString("ContestId");
        const EmployeeCode = getLocalStoreString("EmployeeCode");
        dispatch({
            type: DASHBOARD_WEEKLY_CONTEST,
            payload: { contestId, EmployeeCode },
        });
    }

    const handleNavigate = (data) => {
        clevertap.spa = true
        const EmployeeCode = getLocalStoreString("EmployeeCode");
        const FirstName = getLocalStoreString("FirstName");
        const LastName = getLocalStoreString("LastName");
        const EmployeeID = getLocalStoreString("EmployeeID");
        clevertap.spa = true
        clevertap.event.push("Weekly Contest", {
            "Name": FirstName + ' ' + LastName,
            "Identity": EmployeeID,
            "Emp-Code": EmployeeCode,
            "Emp-Id": EmployeeID,
            "USER-TYPE": server == 'UAT' ? 'UAT User' : "PROD User",
        });
        navigate(WEEKLY_CONTEST, { state: data });
    }



    const card = (
        <>
            {dashboardWeeklyContest && dashboardWeeklyContest?.leaderboards && dashboardWeeklyContest.leaderboards.length > 0 && dashboardWeeklyContest.leaderboards.map((data) => {
                return (
                    <div className='weeklyContest-container' onClick={() => handleNavigate(data)} >
                        <div className='weeklyContest-container_title'>
                            <div style={{ padding: '0rem 4rem 0rem 0rem' }}>
                                <Typography className='weeklyContest-container_title_content'>{data?.uiElement?.title}</Typography>
                                <p className='weeklyContest-container_title_status'>{data.status}</p>
                            </div>
                            <div>
                                <img src={crown} className='' alt='' />
                            </div>
                        </div>
                        <div className='weeklyContest-container_box'>
                            <div className='weeklyContest-container_box_coinbox'>
                                <div className='weeklyContest-container_box_coinbox_innerBox1'>
                                    <Typography className='weeklyContest-container_box_coinbox_innerBox1_text' >Coins Won</Typography>
                                    <div className='weeklyContest-container_box_coinbox_innerBox1_coin-icon' >
                                        <img src={coinsWon} className='' alt='' />&nbsp;&nbsp;
                                        {data.entry.coins}
                                    </div>
                                </div>
                                <div className='weeklyContest-container_box_coinbox_innerBox2'>
                                    <Typography className='weeklyContest-container_box_coinbox_innerBox2_text'>Completed on Time %</Typography>
                                    <div >
                                        <Typography lassName='weeklyContest-container_box_coinbox_innerBox2_percentage' color='white' >100%</Typography>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <Typography className='weeklyContest-container_box_rank'>{data.entry.rank}</Typography>
                                <p className='weeklyContest-container_box_rankText'>{myRank}</p>
                            </div>
                        </div>
                    </div>
                )
            })}
        </>
    );

    return (
        <>
            <Box  >
                <Card className='card' variant="outlined" style={{ display: 'flex', overflowX: 'auto', gap: '10px', minWidth: '39rem' }}>{card}</Card>
            </Box>
        </>

    )
}

const mapStateToProps = (state) => {
    return {
        dashboardWeeklyContest: state.dashboardConfig.dashboardWeeklyContestData,
    }
}

export default weeklyContest;